import { render, staticRenderFns } from "./FontAttrsItem.vue?vue&type=template&id=70617cc4&"
import script from "./FontAttrsItem.vue?vue&type=script&lang=js&"
export * from "./FontAttrsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/attr/items/FontAttrsItem.vue"
export default component.exports